import React, { Component } from 'react';
import Firebase from 'firebase';

export default class clientData extends React.Component {
    constructor() {
        super();
        this.state = {
            client: {},
            numStores: "",
            numUsuarios: ""
        }
    }

    componentWillMount() {
        const contex = this;
        var clientRef = Firebase.database().ref('clients')
            .child(localStorage.client_id)
            .once('value')
            .then(resp => { this.setState({ client: resp.val() }) });
        var numUsuarios = Firebase.database().ref('clients_users')
            .child(localStorage.client_id)
            .once('value', function (snapshot) {
                contex.setState({ numUsuarios: snapshot.numChildren() });
            });
        var numStores = Firebase.database().ref('stores')
            .child(localStorage.client_id)
            .once('value', function (snapshot) {
                contex.setState({ numStores: snapshot.numChildren() });
            })
        var formRef = Firebase.database().ref("forms");
        formRef
            .orderByChild('client_id')
            .equalTo(localStorage.client_id)
            .once('value', function (snapshot) {
                contex.setState({ numForms: snapshot.numChildren() });
            })
    }

    render() {
        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header">
                        <strong>Información General</strong>
                    </div>
                    <div className="card-block">
                        <div className="callout callout-success">
                            <h4 >{this.state.client.name}</h4>
                            <p>Datos de la empresa:</p>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-sm-2">
                                <div className="callout callout-info">
                                    <small className="text-muted">N° de usuarios</small><br />
                                    <strong className="h4">{this.state.numUsuarios}</strong>
                                </div>
                            </div>
                            <div className="col-sm-2">
                                <div className="callout callout-danger">
                                    <small className="text-muted">Nº de Locales</small><br />
                                    <strong className="h4">{this.state.numStores}</strong>
                                </div>
                            </div>
                            <div className="col-sm-2">
                                <div className="callout callout-warning">
                                    <small className="text-muted">N° de Formularios</small><br />
                                    <strong className="h4">{this.state.numForms}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/account/clientData.js